module.exports = __webpack_public_path__ + "static/media/request.00ba96d1.mp3";